import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import ScrollContainer from 'react-indiana-drag-scroll'
import useApi from '../../api/useApi';
import ChatService from '../../services/ChatService';
import UsersService from '../../services/UsersService';
import Moment from 'react-moment';
import Skeleton from 'react-loading-skeleton'
//import 'react-loading-skeleton/dist/skeleton.css'
import { NumericFormat } from 'react-number-format';
import useSound from 'use-sound';
import timeupSound from '../../timeup.mp3';
import reRunSound from '../../reRun.mp3';
import logo from '../../images/SB_LOGO.png'
import boltwareLogo from '../../images/BoltwareLogo.png'
import '../../streamer.css';
//import { Flash } from '@lab49/react-value-flash';



const LiveStream = () => {
    const navigate = useNavigate();
    const [auctionStatus, setAuctionStatus] = useState(null);
    const [auctionData, setAuctionData] = useState({});
    const [currentBidAmount, setCurrentBidAmount] = useState(0);
    const [play] = useSound(timeupSound);
    const [playReRun] = useSound(reRunSound);
    const [participantList, setParticipantList] = useState([]);
    const [playSound, setPlaySound] = useState(false);
    const [playReRunSound, setPlayReRunSound] = useState(false);
    const [auctionInProgress, setAuctionInProgress] = useState(false);
    const [lotList, setLotList] = useState([]);
    const [lotDetail, setLotDetails] = useState({});
    const [currentBids, setCurrentBids] = useState([]);
    const [bid, setBid] = useState({});
    const [modalMessage, setModalMessage] = useState({});
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const [incrementSeconds, setIncrementSeconds] = useState(2);
    const [modalVisible, setModalVisible] = useState(false);
    const api = useApi();

    const loadCurrentUsers = async () => {
        await api.getCurrentConnectedTraders().then((data) => {

            setParticipantList(data);
        })
    }

    useEffect(() => {
        loadCurrentUsers();
    }, []);


    const handleModalShow = (resetLot = false, autoHide = false) => {
        setModalVisible(true);


        if (autoHide) {
            setTimeout(() => {
                handleModalClose();
                if (resetLot)
                    setSelectedLot(null);
            }, 3000)
        }
    };

    const handleModalClose = () => {
        setModalVisible(false);
    };


    const [selectedLot, setSelectedLot] = useState(null);
    const scrollContainerRef = useRef(null);
    const [auctionTime, setAuctionTime] = useState(7);
    const lotListRef = React.useRef(lotList);

    const getCurrentAuction = async () => {
        try {
            const _msg = {
                message: "GET_LIVE_STREAM_DATA"
            }
            _chatService.sendMessage(_msg);

        } catch (error) {
            alert('Unable to get current auction.');
        }
    };

    const handleOnConnectionEstablished = useRef(() => {
        getCurrentAuction();

    }).current;

    useEffect(() => {
        setTimeout(() => {
            setPlaySound(false);
        }, 2500);

    }, [playSound]);

    useEffect(() => {
        setTimeout(() => {
            setPlayReRunSound(false);
        }, 2500);

    }, [playReRunSound]);

    useEffect(() => {

        if (auctionData?.currentLot)
            setAuctionInProgress(true);
        else
            setAuctionInProgress(false);

        setWidth(window.innerWidth);
        setHeight(window.innerHeight);

    }, [auctionData?.currentLot]);

    const handleOnMessageReceived = useRef((message) => {
        //console.log("Message Received ")
        //console.log(message)

        if (message) {
            switch (message.message) {
                case 'LIVE_STREAM':
                    {
                        if (message.payload) {
                            setAuctionData(message.payload);
                            setCurrentBidAmount(message.payload?.currentLot?.auctionStartPriceRs);
                        }
                        break;
                    }
                case 'START_LOT':
                    {
                        if (message.payload) {
                            setAuctionData(prevState => ({
                                ...prevState,
                                currentLot: {
                                    ...message.payload.currentLotDetail,
                                }
                            }));
                            setCurrentBidAmount(message.payload?.currentLotDetail?.auctionStartPriceRs);
                        }
                        break;
                    }
                case 'PLACE_BID':
                    {
                        if (message.payload) {
                            setCurrentBidAmount(message?.bidAmount);
                        }
                        break;
                    }
                case 'LOT_SOLD':
                    {
                        if (message.payload) {
                            setPlaySound(true);
                            setModalMessage({
                                lotNo: message.payload.lotNumber,
                                bidAmount: message.payload.bidAmount,
                                type: 'success',
                                message: 'Lot has been SOLD.'
                            });
                            handleModalShow(true, true);

                            setAuctionData(prevState => ({
                                ...prevState,
                                currentLot: null
                            }));
                            getCurrentAuction();
                        }
                        break;
                    }
                case 'LOT_WITHDRAWN':
                    {
                        if (message.payload) {
                            setPlaySound(true);
                            setModalMessage({
                                lotNo: message.payload.lotNumber,
                                type: 'warning',
                                message: 'Lot has been WITHDRAWN.'
                            });
                            handleModalShow(true, true);

                            setAuctionData(prevState => ({
                                ...prevState,
                                currentLot: null
                            }));
                            getCurrentAuction();
                        }
                        break;
                    }
                case 'LOT_RERUN':
                    {
                        if (message.payload) {
                            setPlayReRunSound(true);
                            setModalMessage({
                                type: 'error',
                                lotNo: message.payload.lotNumber,
                                message: 'Lot is being RE-RUN'
                            });
                            handleModalShow(true, true);

                            setAuctionData(prevState => ({
                                ...prevState,
                                currentLot: null
                            }));
                            getCurrentAuction();
                        }
                        break;
                    }
                case 'AUCTION_CLOSED':
                    {
                        setModalMessage({
                            type: 'error',
                            message: 'AUCTION CLOSED'
                        });
                        handleModalShow(true, true);
                        setTimeout(() => {
                            navigate('/streamer')
                        }, 3000)

                        break;
                    }
                default:
            }
        }
    }).current;

    const handleOnTimerTick = useRef((seconds) => {
        setAuctionTime(seconds);

    }).current;

    const handleOnTimerTimeout = useRef((lotId) => {

        setAuctionData(prevState => ({
            ...prevState,
            currentLot: {
                ...prevState.currentLot,
                status: 4 //get actual status here
            }
        }));
        //auctionData?.currentLot
    }).current;

    const handleOnUserJoined = useRef((user) => {
        setParticipantList((prevUsers) => [...prevUsers, user]);
    }).current;

    const handleOnUserLeft = useRef((user) => {
        //console.log("user left");
        //console.log(user);
        setParticipantList((prevUsers) => prevUsers.filter((participant) => participant.userCode !== user.userCode));
    }).current;


    const _chatService = ChatService({ onConnectionEstablished: handleOnConnectionEstablished, socketLoggedOnCallback: handleOnUserJoined, socketLoggedOutCallback: handleOnUserLeft, messageReceived: handleOnMessageReceived, timerTick: handleOnTimerTick, timerTimeout: handleOnTimerTimeout });

    const handleScroll = () => {

        const container = scrollContainerRef.current.container.current;
        const scrollPosition = scrollContainerRef.current.container.current.scrollLeft
        console.log(scrollPosition)

        const activeBagContainer = document.getElementById('active-bag-container')
        const activeContainerStart = activeBagContainer.getBoundingClientRect().left;
        const activeContainerWidth = activeBagContainer.getBoundingClientRect().width;
        const activeContainerEnd = activeContainerStart + activeContainerWidth;

        const firstVisibleLot = lotListRef.current.find((lot, index) => {
            const lotElement = document.getElementById(`lot-${lot.lotId}`);
            if (lotElement) {
                const { left, right } = lotElement.getBoundingClientRect();

                return left >= activeContainerStart && right <= activeContainerEnd;
            }
            return false;
        });
        setSelectedLot(firstVisibleLot)
        //// Do something with the firstVisibleLot
        //console.log('First visible lot:', firstVisibleLot);
    };

    const scrollToLot = async (lotId) => {

        //console.log("scroll initiated ");
        const container = scrollContainerRef.current.container.current;
        const lotIndex = lotListRef.current.findIndex(t => t.lotId === lotId);
        const lotElement = document.getElementById(`lot-${lotId}`);
        //console.log("lotIndex " + lotIndex)
        //console.log("(lotIndex*60) " + (lotIndex * 60))
        if (lotElement) {
            //console.log("2");
            container.scrollTo({
                left: (lotIndex * 60), // Adjust based on your use case (e.g., left or top)
                behavior: 'smooth', // You can use 'auto' or 'smooth' for the scrolling behavior
            });
        }
    }

    const handleOnScrollEnd = () => {
        const container = scrollContainerRef.current.container.current;
        const scrollPosition = scrollContainerRef.current.container.current.scrollLeft;
        const nearestMultiple = Math.round(scrollPosition / 60) * 60;

        if (scrollPosition % 60 !== 0) {
            container.scrollTo({
                left: nearestMultiple, // Adjust based on your use case (e.g., left or top)
                behavior: 'smooth', // You can use 'auto' or 'smooth' for the scrolling behavior
            });
        }
    }

    //const bagRenderer = (props) => {

    //    let bag;
    //    switch (props.status) {
    //        case [1, 2, 3, 4, 5].find(t => t === props.status):
    //            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-green">
    //                <span>{props.lotNumber}</span>
    //                <span className="current-bag"></span>
    //            </span>
    //            break;
    //        case 6:
    //            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-withdrawn">
    //                <span>{props.lotNumber}</span>
    //            </span>
    //            break;
    //        case 7:
    //            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-skip">
    //                <span>{props.lotNumber}</span>
    //            </span>
    //            break;
    //        case 8:
    //            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-sold">
    //                <span>{props.lotNumber}</span>
    //            </span>
    //            break;
    //        default:
    //            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-green">
    //                <span>{props.lotNumber}</span>
    //            </span>
    //    }

    //    return bag;
    //}
    const bagRenderer = (props) => {
        //console.log(window.innerWidth)
        let bag;
        const indicator = [1, 2, 3, 4, 5].find(t => t === props.status) ? <span className="current-bag"></span> : null;
        if (props.isSpecialLot && props.status === 7) { //special lot skip
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special-skip">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.isSpecialLot && props.status === 6) { //special lot withdrawn
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special-withdrawn">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        } else if (props.isSpecialLot && props.status === 8) { //special lot sold
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special-sold">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.isSpecialLot) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.isColoredLot) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-colored">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.isSuspectedLot) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-suspected">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.status === 6) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-withdrawn">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        } else if (props.status === 7) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-skip">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.status === 8) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-sold">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-green">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        return bag;
    }


    return (
        <div tabIndex={0} className="streamer inner-body no-focus mg-b-10 container-sm d-flex flex-1 flex-column justify-content-around no-bottom-margin" >
            <div className="d-flex justify-content-between steamer-header">
                <div className="d-flex align-items-center col-7" >
                    <img src={logo} className="header-brand-img desktop-logo" alt="logo" />
                    <h2 className="ms-4 mg-b-4 tx-medium participants  streamer-card-text2">Spices Board e-Auction System</h2>
                </div>
                <div className="d-flex align-items-center justify-content-end col-5">
                    <h2 className="tx-medium participants  streamer-card-text2">Auction No / Date : <span className="streamer-color-green">{auctionData?.auction?.auctionNo} / <Moment format="DD-MMM-YYYY">{auctionData?.auction?.auctionDate}</Moment></span> </h2>
                </div>

            </div>
            {/*<iframe src={timeupSound} allow="autoplay" id="audio" style="display: none"></iframe>*/}
            {playSound ?
                <audio id="player" autoPlay >
                    <source src={timeupSound} type="audio/mp3" />
                </audio> : null}

            {playReRunSound ?
                <audio id="player2" autoPlay >
                    <source src={reRunSound} type="audio/mp3" />
                </audio> : null}

            <div className="row row row-sm" style={{ height: '75vh' }}>

                <div className="col-9 d-flex flex-column justify-content-evenly">

                    <div className="card custom-card cardVHheight1"  >
                        <div className="card-body pg-l-4 d-flex align-items-center">
                            <div className="d-flex  pd-l-4">
                                <span className="streamer-card-title">Auctioneer: </span>
                                <h4 className="mg-0 streamer-card-text2 streamer-color-green mg-l-10 ">{auctionData?.auction?.companyName}</h4>
                            </div>
                        </div>
                    </div>

                    <div className="row  row-sm d-flex  justify-content-around">
                        <div className=" col-3">
                            <div className="card custom-card mg-b-14 cardVHheight1">
                                <div className="card-body text-center">
                                    <div className="d-flex flex-column ">
                                        <span className="streamer-card-text3">Total Lots</span>
                                        <h2 className="mg-0 streamer-card-text1 streamer-color-green"> {auctionData?.lotSummary?.totalLots}  </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" col-3">
                            <div className="card custom-card mg-b-14 cardVHheight1">
                                <div className="card-body text-center">
                                    <div className="d-flex flex-column">
                                        <span className="streamer-card-text3">Lots Remaining</span>
                                        <h2 className="mg-0 streamer-card-text1 streamer-color-green"> {auctionData?.lotSummary?.lotsRemaining}  </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" col-3">
                            <div className="card custom-card mg-b-18 cardVHheight1">
                                <div className="card-body text-center">
                                    <div className="d-flex flex-column">
                                        <span className="streamer-card-text3">Lots Sold</span>
                                        <h2 className="mg-0 streamer-card-text1 streamer-color-green"> {auctionData?.lotSummary?.lotsSold} </h2>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className=" col-3">
                            <div className="card custom-card mg-b-0 cardVHheight1">
                                <div className="card-body text-center">
                                    <div className="d-flex flex-column">
                                        <span className="streamer-card-text3">Lots Withdrawn</span>
                                        <h2 className="mg-0 streamer-card-text1 streamer-color-green"> {auctionData?.lotSummary?.lotsWithdrawn}  </h2>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>

                    <div className="card custom-card cardVHheight2">
                        <div className="card-body p-1 d-flex justify-content-center align-items-center">
                            <div className="col-12 d-flex flex-column">
                                <div >
                                    {auctionData?.currentLot ?
                                        <div className="d-flex ">
                                            <div className="mg-b-6 col-3 streamer-padding text-center bd-1 bd-b"> {/*style={{ backgroundColor: '#CDDC39' }}*/}
                                                <div className="d-flex flex-column ">
                                                    <span className="streamer-card-text3">Number of Bags</span>
                                                    <h2 className="mg-0 streamer-card-text1 txt-bold streamer-color-green"><NumericFormat displayType="text" value={auctionData?.currentLot?.bags} allowLeadingZeros thousandSeparator="," decimalScale={2} /></h2>
                                                </div>
                                            </div>
                                            <div className="mg-b-6 col-3 streamer-padding text-center  bd-1 bd-b"> {/*style={{ backgroundColor: '#FFEB3B' }}*/}
                                                <div className="d-flex flex-column ">
                                                    <span className="streamer-card-text3 ">Lot Quantity</span>
                                                    <h2 className="mg-0 streamer-card-text1 txt-bold streamer-color-green"><NumericFormat displayType="text" value={auctionData?.currentLot?.quantityKg} allowLeadingZeros thousandSeparator="," decimalScale={2} />kg </h2>
                                                </div>
                                            </div>
                                            <div className="mg-b-6 col-3 streamer-padding text-center  bd-1 bd-b"> {/*style={{ backgroundColor: '#CDDC39' }}*/}
                                                <div className="d-flex flex-column ">
                                                    <span className="streamer-card-text3  ">Graded/Tested</span>
                                                    <h2 className="mg-0 mg-t-8 streamer-card-text2 streamer-color-green">{auctionData?.currentLot?.grade}</h2>
                                                </div>
                                            </div>
                                            <div className="mg-b-6 col-3 streamer-padding text-center bd-1 bd-b"> {/*style={{ backgroundColor: '#FFEB3B' }}*/}
                                                <div className="d-flex flex-column ">
                                                    <span className="streamer-card-text3 ">Reserve Price</span>
                                                    <h2 className="mg-0 streamer-card-text1 streamer-color-green">{auctionData?.currentLot?.reservedPrice !== null ? "Yes" : "-"}</h2>
                                                </div>
                                            </div>
                                        </div> :
                                        <div>
                                            {/*{awaitCurrentLot}*/}
                                            {/*{awaitCurrentLot}*/}
                                            {/*{awaitCurrentLot}*/}
                                        </div>
                                    }
                                </div>
                                {auctionData?.currentLot ?
                                    <div className="text-center d-flex justify-content-evenly" style={{ marginTop: '4vmin' }}>
                                        <div className="d-flex flex-column justify-content-around align-items-center col-4">
                                            <p className="mg-t-10  streamer-card-text3">Processing lot number... </p>
                                            <div className="lot-bag bag-auction align-items-center">
                                                <span className="tx-gray-200 tx-bold mg-t-15 ">{auctionData?.currentLot?.lotNumber}</span>
                                            </div>
                                            <h5 className="mg-b-25 mg-l-10  streamer-card-text3">
                                                {auctionData?.currentLot?.planterDealer === '1' ? 'Planter' : (auctionData?.currentLot?.planterDealer === '2' ? 'Dealer' : auctionData?.currentLot?.planterDealer) || "--"}
                                            </h5>
                                        </div>
                                        <div className="pricing-plans col-7">
                                            <div className="d-flex justify-content-center ">
                                                <div className="spinner-grow spinner-grow-sm me-1" role="status">
                                                </div>
                                                <h5 className="text-center streamer-card-text3">Current Price</h5>
                                            </div>
                                            <span className="price-value1">
                                                <i className="fa fa-rupee rupee-symbol"></i>
                                                <span className="display-1 tx-medium current-price streamer-card-large" >
                                                    {currentBidAmount}
                                                </span>
                                            </span>
                                            {/*<span className="month">/kg</span>*/}
                                        </div>

                                    </div> : awaitNextLot}
                            </div>

                        </div>
                    </div>


                </div>

                <div className="col-3 d-flex flex-column ">

                    <div className="card custom-card mg-b-14 cardVHheight1">
                        <div className="card-body text-center">
                            <div className="d-flex flex-column ">
                                <span className="streamer-card-text3">Total Participants</span>
                                <h2 className="mg-0 streamer-card-text1 streamer-color-green">{participantList.length} </h2>
                            </div>
                        </div>
                    </div>

                    <div className="card custom-card mg-b-14 cardVHheight1">
                        <div className="card-body text-center">
                            <div className="d-flex flex-column ">
                                <span className="streamer-card-text3">Total Quantity</span>
                                <h2 className="mg-0 streamer-card-text1 streamer-color-green"><NumericFormat displayType="text" value={auctionData?.lotSummary?.totalQuantity} allowLeadingZeros thousandSeparator="," decimalScale={2} />kg </h2>
                            </div>
                        </div>
                    </div>

                    <div className="card custom-card mg-b-14 p-1">
                        <div className="card-body text-center">
                            <div className="d-flex flex-row">
                                <div className="col-6 d-flex flex-column bd-r no-padding" >
                                    <span className="streamer-card-text4">Planter Qty</span>
                                    <h2 className="mg-0 streamer-card-text2 streamer-color-green"><NumericFormat displayType="text" value={auctionData?.lotSummary?.planterQty} allowLeadingZeros thousandSeparator="," decimalScale={2} />kg </h2>
                                </div>
                                <div className="col-6 d-flex flex-column no-padding">
                                    <span className="streamer-card-text4"> Dealer Qty</span>
                                    <h2 className="mg-0 streamer-card-text2 streamer-color-green"><NumericFormat displayType="text" value={auctionData?.lotSummary?.dealerQty} allowLeadingZeros thousandSeparator="," decimalScale={2} />kg </h2>
                                </div>
                            </div>
                            
                        </div>
                    </div>
 

                    <div className="card custom-card " >
                        <div className="card-body px-2">
                            <div className="item1-links flex-column mb-0 nav nav-pills" role="tablist">
                                <li className="custom-list-card align-items-center ">
                                    <h6 className="mt-2 streamer-card-text3"> Auction Avg.</h6>
                                    <h4 className="streamer-card-text6 streamer-color-green align-self-end text-bold"><NumericFormat displayType="text" value={auctionData?.lotSummary?.auctionAvg} allowLeadingZeros thousandSeparator="," decimalScale={2} /></h4>
                                </li>
                                <li className="custom-list-card align-items-center ">
                                    <h6 className="mt-2 pd-t-2 streamer-card-text3"> Grower Avg.</h6>
                                    <h4 className="streamer-card-text1 streamer-color-green align-self-end  text-bold"><NumericFormat displayType="text" value={auctionData?.lotSummary?.growerAvg} allowLeadingZeros thousandSeparator="," decimalScale={2} /></h4>
                                </li>
                                <li className="custom-list-card align-items-center ">
                                    <h6 className="mt-2 pd-t-2 streamer-card-text3"> Dealer Avg.</h6>
                                    <h4 className="streamer-card-text1 streamer-color-green  align-self-end  text-bold"><NumericFormat displayType="text" value={auctionData?.lotSummary?.dealerAvg} allowLeadingZeros thousandSeparator="," decimalScale={2} /></h4>
                                </li>
                                <li className="custom-list-card align-items-center ">
                                    <h6 className="mt-2 pd-t-2 streamer-card-text3"> Minimum</h6>
                                    <h4 className="streamer-card-text1 streamer-color-green align-self-end  text-bold"><NumericFormat displayType="text" value={auctionData?.lotSummary?.auctionMin} allowLeadingZeros thousandSeparator="," decimalScale={2} /></h4>
                                </li>
                                <li className="custom-list-card align-items-center ">
                                    <h6 className="mt-2 pd-t-2 streamer-card-text3"> Maximum</h6>
                                    <h4 className="streamer-card-text1 streamer-color-green  align-self-end  text-bold"><NumericFormat displayType="text" value={auctionData?.lotSummary?.auctionMax} allowLeadingZeros thousandSeparator="," decimalScale={2} /></h4>
                                </li>
                               
                            </div>
                        </div>
                    </div>



                </div>
            </div>

            {/*TO FIX BELOW DIV TO BOTTOM OF PAGE; JUST ADD flex-1 CLASS BELOW */}
            {/*<div className="d-flex flex-column justify-content-end no-bottom-margin" >*/}
            {/*    <div className="row  ">*/}
            {/*        <div className="col-md-12 ">*/}
            {/*            <div className="card custom-card mg-b-0 overflow-hidden bg-light123" style={{ borderWidth: '1px', borderColor: '#1e2032', borderStyle: "solid" }}>*/}

            {/*                {auctionData?.currentLot?.status === 24 ?*/}
            {/*                    <div className="d-flex justify-content-center">*/}
            {/*                        <h2 className="mg-10 pd-2 streamer-bid-closed streamer-card-text1">Bidding closed for lot number : {auctionData?.currentLot?.lotNumber}</h2>*/}
            {/*                    </div> :*/}
            {/*                    <ScrollContainer*/}
            {/*                        className="scroll-container d-flex flex-row justify-content-start pd-8 pd-l-140 overflow-x-scroll scrollbar-hide"*/}
            {/*                        onScroll={handleScroll}*/}
            {/*                        vertical={false}*/}
            {/*                        horizontal={false}*/}
            {/*                        ref={scrollContainerRef}*/}
            {/*                        onEndScroll={handleOnScrollEnd}*/}
            {/*                    >*/}
            {/*                        <Skeleton containerClassName="flex-1" height={'100%'} />*/}
            {/*                        {auctionData?.lotList?.map((t, index) => {*/}
            {/*                            return <div key={index} className="lot-bag-container">*/}
            {/*                                {bagRenderer(t)}*/}
            {/*                            </div>*/}
            {/*                        })}*/}
            {/*                    </ScrollContainer>}*/}

            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}


            <div className="card custom-card  mg-t-30 mg-b-14 ">
                <div className="card-body tx-16 d-flex justify-content-center align-items-center" style={{ fontSize: '2vmin' }}>
                    <span>Software service by</span>  <img src={boltwareLogo} style={{ width: '14vmin', marginLeft: '9px', marginRight: '9px' }} /> <span> | www.boltware.in</span>
                </div>
            </div>


            {/*<span className="">width:{width}  | height:{height}  </span>*/}
            <Modal show={modalVisible} centered>
                <Modal.Header className="modal-header pd-12">
                    <Modal.Title>{modalMessage.lotNo ? 'Lot Result' : 'Auction End'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center">
                        {modalMessage.lotNo ? <h1>Lot No. {modalMessage.lotNo} </h1> : null}
                        {modalMessage.bidAmount ? <div className="d-flex justify-content-center">
                            <h2 className="mg-t-4">Bidding closed at  </h2>  <span className="counter mg-l-8 mg-t-4">₹</span><h2 className="mg-t-5">{modalMessage.bidAmount}</h2>
                        </div> : null}
                        <h1 className={modalMessage.type === "success" ? "tx-success" : (modalMessage.type === "error" ? "tx-danger" : "tx-primary")}>{modalMessage.message}</h1>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default LiveStream;


const awaitCurrentLot = (
    <div className="mg-b-7 p-2 text-center w-10" >
        <Skeleton containerClassName="flex-1 w-50" height={20} count={1} style={{ marginBottom: "2px" }} />
    </div>
)

const awaitCurrentAmount = (
    <div className="col-8 text-center d-flex flex-column justify-content-around">
        <Skeleton width={150} height={20} count={1} />
        <Skeleton width={250} height={40} count={1} />
        <Skeleton width={150} height={20} count={2} />
    </div>
)
const awaitNextLot = (
    <div className="text-center d-flex flex-column justify-content-center" >
        <h2>Awaiting new lot start...</h2>
        <Skeleton width={200} height={20} count={1} />
        {/*<Skeleton width={250} height={40} count={1} />*/}
        {/*<Skeleton width={150} height={20} count={2} />*/}
    </div>
)

const awaitLotSummary = (
    <div className="d-flex flex-column">
        <Skeleton containerClassName="flex-1" height={22} count={2} style={{ marginBottom: "2px" }} />
    </div>
)

